import axios from "axios";
import config from "../../config";

const baseUrl = config.baseUrl;
const endpoint = "/api/informe-entregas";

export const obtenerInformeEntregas = async (
  fechaInicio    = null,
  fechaFin       = null,
  codMunicipio   = null
) => {
  try {
    const params = {};
    if (fechaInicio)  params.fechaInicio  = fechaInicio;
    if (fechaFin)     params.fechaFin     = fechaFin;
    if (codMunicipio) params.codMunicipio = codMunicipio;

    const response = await axios.get(`${baseUrl}${endpoint}`, { params });
    return response.data;
  } catch (error) {
    console.error("Error obteniendo informe general de entregas:", error);
    throw error;
  }
};

export const exportarInformeEntregas = async (
  fechaInicio      = null,
  fechaFin         = null,
  codMunicipio     = null,
  nombreMunicipio  = null   // ← nuevo
) => {
  try {
    const params = {};
    if (fechaInicio)     params.fechaInicio     = fechaInicio;
    if (fechaFin)        params.fechaFin        = fechaFin;
    if (codMunicipio)    params.codMunicipio    = codMunicipio;
    if (nombreMunicipio) params.nombreMunicipio = nombreMunicipio;  // ← nuevo

    const response = await axios.get(`${baseUrl}${endpoint}/exportar`, { params });
    return response.data;
  } catch (error) {
    console.error("Error exportando informe de entregas:", error);
    throw error;
  }
};